import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FavoriteButton } from 'shared/components/NewbuildingGallery/components/GallerySidebar';
import { trackFavoriteClick } from 'shared/containers/NewbuildingGallerySidebar/parts/FavoriteButton/tracking';
import { getIsFavorite } from 'shared/selectors';
import { getOfferCustomUrl } from 'shared/selectors/analytics';
import { changeFavoriteAction } from 'shared/store/offer';

export const FavoriteButtonContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isFavorite = useSelector(getIsFavorite);
  const customUrl = useSelector(getOfferCustomUrl);

  const changeFavorite = React.useCallback(() => {
    dispatch(changeFavoriteAction());
    trackFavoriteClick({ isFavorite, label: customUrl });
  }, [isFavorite, customUrl]);

  return <FavoriteButton checked={isFavorite} onButtonClick={changeFavorite} />;
};
